import { render, staticRenderFns } from "./productBatchCommissions.vue?vue&type=template&id=43c59bb2&scoped=true&"
import script from "./productBatchCommissions.vue?vue&type=script&lang=js&"
export * from "./productBatchCommissions.vue?vue&type=script&lang=js&"
import style0 from "./productBatchCommissions.vue?vue&type=style&index=0&id=43c59bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c59bb2",
  null
  
)

export default component.exports